/**
 * Type-safe assertion function that throws if condition is false
 */
export function safeAssert(condition: boolean, message?: string): asserts condition {
  if (!condition) {
    throw new Error(message || 'Assertion failed');
  }
}
